import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginationTableService {

  public buildNavPages(totalPagesP: number): any[] {
    let totalPages = [];
    for (let index = 1; index <= totalPagesP; index++) {
      totalPages.push(index);
    }
    return totalPages;
  }
  
  public resetPageCurrent(): number {
    localStorage.setItem('currentPage', '1');
    return 1;
  };

}
